import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';

export const match2SaveStateActions = createActions({
  /**
   * Save gameplay state
   */
  saveMatch2GameplayState: action(
    (state, args: { level: number; data: string; shortcut?: string }, api) => {
      state.match2.saveState = {
        timestamp: api.date.now(),
        level: args.level,
        data: args.data,
      };
    },
  ),

  /**
   * Delete existing save state
   */
  clearMatch2GameplayState: action((state) => {
    delete state.match2.saveState;
  }),
});
